import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentItineraryPrintPageCtrl implements IController {

  agent: AgentModel;
  itinerary: any;
  tasks: any;

  private currentDate: any;
  private logoUrl: any;
  private lastETA: any;

  constructor(private splitService: SplitService, private $window: IWindowService,
              private $timeout: ITimeoutService, private moment) {
  }

  $onInit() {
    this.currentDate = this.moment().valueOf();
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this.lastETA = this.tasks.length ?
      _.get(_.last(this.tasks), 'analysis.eta') :
      this.moment().valueOf();
  }

  $postLink() {
    this.$timeout(1000).then(() => {
      this.$window.print();
      this.$window.close();
    })
  };
}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryPrintPage', {
    bindings: {
      agent: '<',
      itinerary: '<',
      tasks: '<'
    },
    template: require('./agent-itinerary-print-page.html').default,
    controller: AgentItineraryPrintPageCtrl
  });
